import React from 'react'
import GolfTemplate from 'src/components/page/golf'
import { leagueGroupIds } from 'src/constants/personalizationIds'
import { promoCodes } from 'src/constants'
import styled from 'styled-components'

export default (props) => (
  <StyledContainer>
    <GolfTemplate
      location={props.location}
      poster={'https://assets-imgx.fubo.tv/marketing/lp/images/posters/golf_Web_v3.png'}
      posterMobile={'https://assets-imgx.fubo.tv/marketing/lp/images/posters/golf_Mobile_v3.jpg'}
      subtitle={'Stream 120+ live events from the PGA Tour & more'}
      matchtickerLeagueId={leagueGroupIds.golf}
      offerBanner={{
        title: ['A Special offer for GolfNow users.', 'Enjoy $40 off your first 2 months!'],
      }}
      offerCode={promoCodes.golf_pass_non_members}
      logo={'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-golfpass-v2.png'}
      logoHeight={'70px'}
      noIndex={true}
    />
  </StyledContainer>
)

const StyledContainer = styled.div``
